export const isLocaleEnglish = (language: string): boolean => language === 'en';
